import src from "IMAGE";
export default { src, width: 17, height: 17, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
